/**
 * @generated SignedSource<<f24f55b2991a0d7f58043f2a2ce6a21f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type CashoutMethod = "CHARITY" | "GIFT_CARD" | "PAYPAL" | "VENMO";
export type CashoutProviderStatus = "AVAILABLE" | "OFFLINE" | "REQUIRES_VERIFICATION";
import { FragmentRefs } from "relay-runtime";
export type CashoutProviderButtons_providers$data = {
  readonly providers: ReadonlyArray<{
    readonly name: CashoutMethod;
    readonly status: CashoutProviderStatus;
  }>;
  readonly id: string;
  readonly " $fragmentType": "CashoutProviderButtons_providers";
};
export type CashoutProviderButtons_providers$key = {
  readonly " $data"?: CashoutProviderButtons_providers$data;
  readonly " $fragmentSpreads": FragmentRefs<"CashoutProviderButtons_providers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./CashoutProvidersRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "CashoutProviderButtons_providers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CashoutProvider",
      "kind": "LinkedField",
      "name": "providers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "CashoutProviders",
  "abstractKey": null
};

(node as any).hash = "4761be8425bb2dfd93fe6fff1cfd6872";

export default node;
